import {
  Col,
  Checkbox,
  Form,
  Row,
  Spin,
} from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import ButtonField from "../../common/htmlComponents/ButtonField";
import "../../styles/Main.scss";

const SiteSelectionModel = ({
  siteList,
  handleSave,
  handleCancel,
  setReload,
}) => {
  const [apiLoading1, setApiLoading1] = useState(false);

  useEffect(() => {
    if (siteList.length === 0) {
      setApiLoading1(true);
    } else {
      setApiLoading1(false);
    }
  }, [siteList]);

  const { t } = useTranslation();
  const formRef = useRef();

  /* My List */
  const [checked, setChecked] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(false);

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  useEffect(() => {
    setIndeterminate(checked.length && checked.length !== siteList.length);
  }, [checked]);

  // Back To List
  const backToList = () => {
    handleCancel();
  };

  const onCheckAllChange = (e) => {
    setChecked(e.target.checked ? siteList.map((item) => item.site_name) : []);
    setCheckAll(e.target.checked);
  };

  // Fetch Form Submit
  const handleSubmit = () => {
    try {
      setBtnLoading(true);
      const selectedSites = siteList.filter((site) =>
        checked.includes(site.site_name)
      );
      handleSave(selectedSites);
      setBtnLoading(false);
      handleCancel();
      setReload((reload) => !reload);
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const groupedSites = siteList.reduce((acc, item) => {
    if (!acc[item.city_name]) {
      acc[item.city_name] = [];
    }
    acc[item.city_name].push(item.site_name);
    return acc;
  }, {});

  return (
    <Spin spinning={apiLoading1}>
      <Form
        className="ModalForm"
        onFinish={handleSubmit}
        autoComplete="off"
        ref={formRef}
      >
        <Row gutter={[15]}>
          <Col xs={24} className="TextField radio">
            <Checkbox
              indeterminate={indeterminate}
              onChange={onCheckAllChange}
              checked={checkAll}
            >
              Select All Sites
            </Checkbox>
            <Checkbox.Group
              style={{ width: "100%" }}
              value={checked}
              onChange={(checkedValues) => {
                setChecked(checkedValues);
              }}
            >
              <div
                className=""
                style={{
                  flexDirection: "row",
                  gap: "5px",
                }}
              >
                {Object.entries(groupedSites).map(([city, sites]) => (
                  <div key={city} className="CityGroup">
                    <div className="CityName">{city} :</div>
                    <div className="CitySites" style={{display:"flex", flexWrap:"wrap", width:"max-content"}}>
                    {sites.map((site) => (
                      <div className="CustomListItem radio" key={site}>
                        <Checkbox value={site} className="">
                        <span className="CustomListItemText ">{site}</span>
                        </Checkbox>
                      </div>
                    ))}
                    </div>
                  </div>
                ))}
              </div>
            </Checkbox.Group>
          </Col>
        </Row>
        <div className="ModalPopupFooter" style={{ margin: "15px 0 5px" }}>
          <ButtonField
            className="CancelGradiantBtn"
            type="primary"
            htmlType="button"
            label={t("cancel")}
            onClick={backToList}
          />
          {buttonDisabled ? (
            ""
          ) : (
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Submit"
              label={t("Next")}
              loading={btnLoading}
            />
          )}
        </div>
      </Form>
    </Spin>
  );
};
SiteSelectionModel.propTypes = {
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  setSiteList: PropTypes.func,
  siteList: PropTypes.object,
  setReload: PropTypes.func,
  reload: PropTypes.bool,
  apiLoading: PropTypes.bool,
};

export default SiteSelectionModel;
